import { ReactElement } from 'react';
import { Typography } from 'antd';
import modalsSlice from 'app/store/modals/modals.slice';
import logo from 'assets/logo_short.svg';
import 'app/components/elements/loading_screen/loading_screen.scss';

function LoadingScreen({
    type = 'layout',
    text,
    textFirst = false,
}: {
    type: 'layout' | 'page' | 'element';
    text?: string;
    textFirst?: boolean;
}): ReactElement {
    const { navbar } = modalsSlice((state) => state);
    const respectNavbar = type === 'page' || type === 'element';

    return (
        <div
            className={`loader-wrapper ${type} ${textFirst ? 'text-first' : ''} ${
                !navbar.isToggled && respectNavbar ? 'isCollapsed' : ''
            }`}
        >
            {text && textFirst && (
                <div
                    className={`loader-text is-first ${
                        navbar.isToggled && respectNavbar ? 'isToggled' : ''
                    }`}
                >
                    <Typography.Text className='display-linebreak'>{text}</Typography.Text>
                </div>
            )}
            <div className={`app-loading ${navbar.isToggled && respectNavbar ? 'isToggled' : ''}`}>
                <img className='main-logo' src={logo} alt='' />
                <div className='logo-wrap' />
            </div>
            {text && !textFirst && (
                <div
                    className={`loader-text ${
                        navbar.isToggled && respectNavbar ? 'isToggled' : ''
                    }`}
                >
                    <Typography.Text className='display-linebreak'>{text}</Typography.Text>
                </div>
            )}
        </div>
    );
}

export default LoadingScreen;
